module.exports = __webpack_public_path__ + "media/images/hitfun/icon.like.active.pink-6e843df4abaf9cbd3deec34771ccaeeb.svg";